import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { THEMES, brandFromPath } from "@/lib/themes";

export default function ThemeLayout({ children }) {
  const { pathname } = useLocation();
  const brandKey = brandFromPath(pathname);
  const theme = THEMES[brandKey];

  useEffect(() => {
    const root = document.body;
    Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
    root.setAttribute("data-brand", brandKey);
  }, [brandKey, theme]);

  return <div data-brand-root={brandKey}>{children}</div>;
}
